<nz-modal
  #modalRef
  [(nzVisible)]="isVisible"
  [nzTitle]="'Appointment Details' | translate"
  (nzOnCancel)="closeModal()"
  [nzFooter]="null"
  [nzWrapClassName]="'calendar-modal'"
  [nzWidth]="900"
>
  <ng-container *nzModalContent>
    <!-- GENERAL INFORMATION -->
    <nz-divider
      nzPlain
      [nzText]="'General Information' | translate"
      nzOrientation="left"
      nzVariant="solid"
    ></nz-divider>

    <!-- Title -->
    <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
      <div fxFlex="20">
        <label>{{ "Title" | translate }}</label>
      </div>
      <div fxFlex="80">
        <input
          nz-input
          class="inputs event read-only"
          [value]="event?.title || ('Not set' | translate)"
          disabled
        />
      </div>
    </div>

    <!-- Appointment Status -->
    <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
      <div fxFlex="20">
        <label>{{ "Appointment Status" | translate }}</label>
      </div>
      <div fxFlex="80">
        <input
          nz-input
          class="inputs event read-only"
          [value]="(event?.extendedProps?.['appointmentStatusId']
                     ? getStatusName(appointmentStatusList, event?.extendedProps?.['appointmentStatusId'])
                     : ('Not set' | translate)) | translate"
          disabled
        />
      </div>
    </div>

    <!-- Service Type -->
    <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
      <div fxFlex="20">
        <label>{{ "Service Type" | translate }}</label>
      </div>
      <div fxFlex="80">
        <input
          nz-input
          class="inputs event read-only"
          [value]="(event?.extendedProps?.['appointmentServiceTypeId']
                     ? getStatusName(appointmentServiceTypeList, event?.extendedProps?.['appointmentServiceTypeId'])
                     : ('Not set' | translate)) | translate"
          disabled
        />
      </div>
    </div>

    <!-- Appointment Reason -->
    <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
      <div fxFlex="20">
        <label>{{ "Appointment Reason" | translate }}</label>
      </div>
      <div fxFlex="80">
        <input
          nz-input
          class="inputs event read-only"
          [value]="(event?.extendedProps?.['appointmentReasonId']
                     ? getStatusName(appointmentReasonsList, event?.extendedProps?.['appointmentReasonId'])
                     : ('Not set' | translate)) | translate"
          disabled
        />
      </div>
    </div>

    <!-- Description -->
    <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
      <div fxFlex="20">
        <label>{{ "Description" | translate }}</label>
      </div>
      <div fxFlex="80">
        <textarea
          nz-input
          rows="3"
          class="inputs event read-only"
          [value]="event?.extendedProps?.['description'] || ('Not set' | translate)"
          disabled
        ></textarea>
      </div>
    </div>

    <!-- Recurrence (only if repeated) -->
    @if (isRepeated) {
    <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
      <div fxFlex="20">
        <label>{{ "Duration" | translate }}</label>
      </div>
      <div fxFlex="80">
        <input
          nz-input
          class="inputs event read-only"
          [value]="(event?.extendedProps?.['recurrenceOccurrences'] || ('Not set' | translate)) + ' - ' + getRecurrenceTypeName(event?.extendedProps?.['recurrentTypeId'])"
          disabled
        />
      </div>
    </div>
    }

    <!-- Created By -->
    <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
      <div fxFlex="20">
        <label>{{ "Created By" | translate }}</label>
      </div>
      <div fxFlex="80">
        <input
          nz-input
          class="inputs event read-only"
          [value]="event?.extendedProps?.['createdBy'] || ('Not set' | translate)"
          disabled
        />
      </div>
    </div>

    <!-- DATE & TIME -->
    <nz-divider
      nzPlain
      [nzText]="'Date & Time' | translate"
      nzOrientation="left"
      nzVariant="solid"
    ></nz-divider>

    <!-- Slot: Start -->
    <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
      <div fxFlex="20">
        <label>{{ "Start" | translate }}</label>
      </div>
      <div fxFlex="80">
        <input
          nz-input
          class="inputs event read-only"
          [value]="
            event?.start?.toLocaleString('en-GB', {
              dateStyle: 'short',
              timeStyle: 'short',
              hour12: false
            })
          "
          disabled
        />
      </div>
    </div>

    <!-- Slot: End -->
    <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
      <div fxFlex="20">
        <label>{{ "End" | translate }}</label>
      </div>
      <div fxFlex="80">
        <input
          nz-input
          class="inputs event read-only"
          [value]="
            event?.end?.toLocaleString('en-GB', {
              dateStyle: 'short',
              timeStyle: 'short',
              hour12: false
            })
          "
          disabled
        />
      </div>
    </div>

    <!-- Slot Status -->
    <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
      <div fxFlex="20">
        <label>{{ "Slot Status" | translate }}</label>
      </div>
      <div fxFlex="80">
        <input
          nz-input
          class="inputs event read-only"
          [value]="(event?.extendedProps?.['slotStatusId']
                    ? getStatusName(slotStatusList, event?.extendedProps?.['slotStatusId'])
                    : ('Not set' | translate)) | translate"
          disabled
        />
      </div>
    </div>

    <!-- PARTICIPANTS -->
    <nz-divider
      nzPlain
      [nzText]="'Participants' | translate"
      nzOrientation="left"
      nzVariant="solid"
    ></nz-divider>

    <!-- Member (staff) -->
    <div class="form-row" fxLayout="row" fxLayoutAlign="start start">
      <div fxFlex="20">
        <label
          >{{ "Member" | translate }} ({{
            "s_member_calendar" | translate
          }})</label
        >
      </div>
      <div fxFlex="80">
        <div class="list-pills">
          @for (person of personnel; track person) {
          <span class="pill">
            {{ person.role }} {{ person.title }} ({{
              getStatusName(participantStatusList, person.participantStatusId)
                | translate
            }})
          </span>
          } @if (personnel.length === 0) {
          <span class="muted">{{ "Not set" | translate }}</span>
          }
        </div>
      </div>
    </div>

    <!-- Patient -->
    <div class="form-row" fxLayout="row" fxLayoutAlign="start start">
      <div fxFlex="20">
        <label
          >{{ "Patient" | translate }} ({{
            "s_patient_calendar" | translate
          }})</label
        >
      </div>
      <div fxFlex="80">
        <div class="list-pills">
          @for (patient of patients; track patient) {
          <span class="pill">
            <a
              class="patient-name-link"
              [title]="'View patient information' | translate"
              (click)="goToPatientProfile(patient.id, $event)"
              >{{ patient.title }}</a
            >
            ({{
              getStatusName(participantStatusList, patient.participantStatusId)
                | translate
            }})
          </span>
          } @if (patients.length === 0) {
          <span class="muted">{{ "Not set" | translate }}</span>
          }
        </div>
      </div>
    </div>

    <!-- DELETE CONFIRMATION (shown after Delete) -->
    @if (deletionStarted) {
    <div class="confirm-box" fxLayout="column" fxLayoutGap="10px">
      <label style="font-weight: 500">
        <b>
          {{
            isRepeated
              ? ("You are about to delete a slot from this repeated appointment"
                | translate)
              : ("You are about to delete this appointment" | translate)
          }}:
        </b>
        {{ " " }}
        {{ event?.title || ("Not set" | translate) }}
      </label>

      @if (isRepeated) {
      <div
        class="radio-row"
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutGap="20px"
        fxLayoutWrap
      >
        <label>
          <input
            type="radio"
            name="deleteOption"
            [value]="1"
            [(ngModel)]="selectedOption"
            (change)="onOptionChange(1)"
          />
          <span style="cursor: pointer">{{
            "This slot only" | translate
          }}</span>
        </label>

        <label>
          <input
            type="radio"
            name="deleteOption"
            [value]="2"
            [(ngModel)]="selectedOption"
            (change)="onOptionChange(2)"
          />
          <span style="cursor: pointer">{{
            "This and all follow-up slots" | translate
          }}</span>
        </label>

        <label>
          <input
            type="radio"
            name="deleteOption"
            [value]="3"
            [(ngModel)]="selectedOption"
            (change)="onOptionChange(3)"
          />
          <span style="cursor: pointer">{{ "All slots" | translate }}</span>
        </label>
      </div>
      }

      <div fxLayout="row" fxLayoutAlign="end">
        <button
          nz-button
          class="delete-btn"
          [disabled]="confirmDisabled"
          (click)="confirmDeletion()"
        >
          {{
            confirmDisabled
              ? ("Confirm deletion" | translate) + " (" + countdown + ")"
              : ("Confirm deletion" | translate)
          }}
        </button>
      </div>
    </div>
    }

    <!-- FOOTER (Edit/Delete) -->
    @if (!deletionStarted && !isReadOnly) {
    <div fxLayout="row" fxLayoutAlign="end" class="footer">
      <button
        nz-button
        nzDanger
        class="cancel-btn delete-btn"
        (click)="onDeleteClick()"
      >
        {{ "Delete" | translate }}
      </button>
      <button nz-button nzPrimary class="save-btn" (click)="onEdit()">
        {{ "Edit" | translate }}
      </button>
    </div>
    }
  </ng-container>
</nz-modal>
